import { useRef, useState } from 'react'
import AvatarEditor from 'react-avatar-editor'
import useTranslation from 'next-translate/useTranslation'
import BlurredButton from 'components/common/button/BlurredButton'
import { Button, Slider } from '@mantine/core'

export const AvatarModal = ({
  image,
  uploadAvatar,
  removeAvatar,
}: {
  image: any
  removeAvatar: () => void
  uploadAvatar: (b: any) => void
}) => {
  const { t } = useTranslation('common')
  const [value, setValue] = useState(1)
  const editor = useRef<any>(null)

  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-center bg-[#d9d9d9]">
        <div className="bg-white">
          <AvatarEditor
            image={image}
            ref={editor}
            width={300}
            height={300}
            borderRadius={180}
            border={50}
            color={[192, 192, 192, 0.6]} // RGBA
            scale={value}
            rotate={0}
          />
        </div>
      </div>
      <Slider
        color="cyan"
        size="sm"
        min={0.2}
        styles={{
          label: { display: 'none' },
        }}
        labelAlwaysOn={false}
        max={2}
        step={0.1}
        showLabelOnHover={false}
        value={value}
        onChange={setValue}
      />
      <div className="flex flex-row justify-center">
        <BlurredButton
          onClick={async () => {
            if (editor) {
              const dataUrl = editor?.current?.getImage().toDataURL()
              const result = await fetch(dataUrl)
              const blob = await result.blob()
              const imageURL = window.URL.createObjectURL(blob)
              uploadAvatar(blob)
              //window.open(imageURL, '_blank')
            }
          }}
          type="submit"
        >
          {t('update')}
        </BlurredButton>

        <div className="ml-2">
          <Button variant="outline" onClick={() => removeAvatar()} color="red">
            {t('remove')}
          </Button>
        </div>
      </div>
    </div>
  )
}
